import {
    toast
} from 'react-toastify';
import uuidv4 from 'uuid/v4';
import { adminBlockStatusUpdate } from '../Actions/AdminBlockAction';
import {
    updateBlockedContactAction,
    updateContactWhoBlockedMeAction
} from '../Actions/BlockAction';
import {
    webSettingLocalAction
} from '../Actions/BrowserAction';

import {
    CallConnectionState,
    callConversion,
    callDurationTimestamp,
    callIntermediateScreen,
    isMuteAudioAction,
    resetCallIntermediateScreen,
    resetConferencePopup,
    resetData,
    selectLargeVideoUser,
    setCallQuality,
    setPoorConnectionIcon,
    setPoorConnectionPopUp,
    showConfrence
} from '../Actions/CallAction';
import { deleteAllCallLog, fetchingCallLog } from '../Actions/CallLogAction';
import {
    ChatMessageHistoryDataAction,
    ClearChatHistoryAction,
    ClearChatHistoryActionCommon,
    DeleteChatHistoryAction,
    UpdateFavouriteStatus
} from '../Actions/ChatHistory';
import {
    WebChatConnectionState
} from '../Actions/ConnectionState';
import {
    GroupDataUpdateAction,
    GroupsDataAction,
    GroupsMemberListAction,
    currentCallGroupMembers
} from '../Actions/GroupsAction';
import {
    MediaDownloadDataAction,
    MediaUploadDataAction
} from '../Actions/Media';
import {
    MessageAction,
    MarkChatMessagesSeenAction,
    ReplyMessageAction,
    messageForwardReset,
    messageInfoAction
} from '../Actions/MessageActions';
import {
    PresenceDataAction
} from '../Actions/PresenceAction';
import {
    ActiveChatResetAction,
    RecentChatAction,
    clearLastMessageinRecentChat,
    deleteActiveChatAction,
    updateArchiveStatusRecentChat,
    updateMsgByLastMsgId
} from '../Actions/RecentChatActions';
import {
    RosterDataAction,
    RosterPermissionAction
} from '../Actions/RosterActions';
import {
    RemoveStaredMessagesClearChat,
    RemoveStaredMessagesDeleteChat,
    UpdateStarredMessages
} from '../Actions/StarredAction';
import {
    VCardContactDataAction,
    VCardDataAction
} from '../Actions/VCardActions';
import {
    deleteAllIndexedDb,
    getUserIdFromJid,
    logout,
    normalizeXmlText,
    sendNotification,
    setLocalWebsettings,
    stopRecorder,
    updateMuteSettings,
    updateMuteStatus
} from '../Helpers/Utility';
import callLogs from './WebCall/CallLogs/callLog';
import {
    REACT_APP_CONTACT_SYNC,
    REACT_APP_XMPP_SOCKET_HOST
} from './processENV';
import SDK from './SDK';
import {
    login,
    reconnect,
    serverReconnect
} from './WebChat/Authentication/Reconnect'
import Store from '../Store';
import {
    deleteItemFromLocalStorage,
    encryptAndStoreInLocalStorage,
    encryptAndStoreInSessionStorage,
    getFromLocalStorageAndDecrypt,
    getFromSessionStorageAndDecrypt
} from './WebChat/WebChatEncryptDecrypt';
import {
    getConnectionStatus,
    setConnectionStatus
} from './WebChat/Common/FileUploadValidation'
import {
    showModal,
    hideModal
} from '../Actions/PopUp';
import {
    resetPinAndLargeVideoUser,
    dispatchDisconnected,
    updateCallTypeAfterCallSwitch,
    startCallingTimer,
    startMissedCallNotificationTimer,
    clearMissedCallNotificationTimer,
    handleCallParticipantToast,
    disconnectCallConnection,
    clearOldCallingTimer
} from '../Helpers/Call/Call';
import {
    CALL_CONVERSION_STATUS_CANCEL,
    CALL_CONVERSION_STATUS_REQ_WAITING,
    CALL_BUSY_STATUS_MESSAGE,
    CALL_ENGAGED_STATUS_MESSAGE,
    CALL_STATUS_CONNECTED,
    DISCONNECTED_SCREEN_DURATION,
    CALL_TYPE_AUDIO,
    CALL_TYPE_VIDEO,
    CALL_STATUS_RECONNECT,
    CALL_STATUS_HOLD,
    CALL_STATUS_ENDED,
    CALL_STATUS_ATTENDED
} from '../Helpers/Call/Constant';
import browserNotify from '../Helpers/Browser/BrowserNotify';
import {
    getActiveConversationChatId,
    getArchivedChats,
    handleTempArchivedChats,
    isActiveConversationUserOrGroup,
    isGroupChat,
    isSameSession
} from '../Helpers/Chat/ChatHelper';
import {
    CARBON_LOGOUT,
    CHAT_TYPE_GROUP,
    CONNECTION_STATE_CONNECTING,
    DELETE_CALL_LOG,
    GROUP_PROFILE_INFO_UPDATED,
    GROUP_USER_ADDED,
    GROUP_USER_LEFT,
    GROUP_USER_MADE_ADMIN,
    GROUP_USER_REMOVED,
    LOGOUT,
    MSG_CHAT_SEEN_ALL,
    MSG_CLEAR_CHAT,
    MSG_CLEAR_CHAT_CARBON,
    MSG_DELETE_CHAT,
    MSG_DELETE_CHAT_CARBON
} from '../Helpers/Chat/Constant';
import {
    getGroupData,
    setGroupParticipants,
    setGroupParticipantsByGroupId
} from '../Helpers/Chat/Group';
import {
    formatUserIdToJid,
    getDataFromRoster,
    getLocalUserDetails,
    getLocalUserId,
    getUserDetails,
    isLocalUser,
    isSingleChatJID
} from '../Helpers/Chat/User';
import { deletedUserInfo, setUserInfoArr } from '../Slice';
import { handleIconTabUnreadChannel } from '../channels/utils/services';
import { handleIncomingChannelEvents } from '../channels/utils';
import { PrivacySettingsAction } from '../Actions/PrivacySettingsAction';

let localStream = null,
    localVideoMuted = false,
    localAudioMuted = false,
    onCall = false,
    localUserOnCall = false;
let remoteVideoMuted = [],
    remoteStream = [],
    remoteAudioMuted = [];

// Participants already announced with a "joined" toast for the current call. remoteStream
// is cleared during a network drop (the "connecting" state), so it can't be used to detect
// a genuine new join vs. a reconnect echo — this Set persists across reconnects and is
// cleared only when the call actually ends, so reconnecting never re-toasts existing peers.
let announcedCallParticipants = new Set();

export const resetCallData = () => {
    const callIntermediateScreen = Store.getState().callIntermediateScreen;
    if (callIntermediateScreen?.data?.show) return;
    onCall = false;
    localUserOnCall = false;
    remoteStream = [];
    announcedCallParticipants.clear();
    localStream = null;
    remoteVideoMuted = [];
    remoteAudioMuted = [];
    localVideoMuted = false;
    localAudioMuted = false;
    if (getFromLocalStorageAndDecrypt("isNewCallExist") === true) {
        deleteItemFromLocalStorage("isNewCallExist")
    } else {
        Store.dispatch(resetCallIntermediateScreen());
    }
    resetData();
    clearOldCallingTimer();
    Store.dispatch(isMuteAudioAction(false));
    Store.dispatch(setCallQuality("GOOD"));
    Store.dispatch(setPoorConnectionIcon(false));
    Store.dispatch(setPoorConnectionPopUp(false));
};

export const muteLocalVideo = (isMuted) => {
    localVideoMuted = isMuted;
    let vcardData = getLocalUserDetails();
    let currentUser = vcardData?.fromUser;
    currentUser = currentUser + "@" + REACT_APP_XMPP_SOCKET_HOST
    remoteVideoMuted[currentUser] = isMuted;
};

export const muteLocalAudio = (isMuted) => {
    localAudioMuted = isMuted;
    let vcardData = getLocalUserDetails();
    let currentUser = vcardData?.fromUser;
    currentUser = currentUser + "@" + REACT_APP_XMPP_SOCKET_HOST
    remoteAudioMuted[currentUser] = isMuted;
};

const updatingUserStatusInRemoteStream = (usersStatus) => {
    usersStatus.map((user) => {
        const index = remoteStream.findIndex(item => item.fromJid === user.userJid);
        if (index > -1) {
            const status = user.status ? user.status.toLowerCase() : "";
            remoteStream[index] = {
                ...remoteStream[index],
                platform: user.platform || '',
                status: (remoteStream[index].status === CALL_STATUS_RECONNECT && status === CALL_STATUS_ATTENDED) ? remoteStream[index].status : status
            };
            remoteVideoMuted[user.userJid] = user.videoMuted;
            remoteAudioMuted[user.userJid] = user.audioMuted;
        } else {
            let streamObject = {
                id: uuidv4(),
                fromJid: user.userJid,
                platform: user.platform || '',
                status: user.status || CONNECTION_STATE_CONNECTING
            }
            remoteStream.push(streamObject);
            remoteVideoMuted[user.userJid] = user.videoMuted;
            remoteAudioMuted[user.userJid] = user.audioMuted;
        }
    });
}

const removingRemoteStream = (res) => {
    remoteStream.forEach((item, key) => {
        if (item.fromJid === res.userJid) {
            remoteStream.splice(key, 1);
        }
    });
}

export const removeRemoteStream = (userJid) => {
    remoteStream.forEach((item, key) => {
        if (item.fromJid === userJid) {
            remoteStream.splice(key, 1);
        }
    });
}

export const getRemoteStream = () => remoteStream;

const updateStoreRemoteStream = () => {
    const {
        getState
    } = Store;
    const {
        data = {}
    } = getState().showConfrenceData;
    Store.dispatch(showConfrence({
        ...data,
        remoteStream
    }));
}

// Tear the call screen down when no remote participant remains. Used when a remote
// user leaves (e.g. failed to reconnect within the timeout) and the call effectively
// has no other peer left — a one-to-one call must end, and a group that has emptied
// out should not keep a stale call UI open.
const endCallAfterAllRemoteLeft = () => {
    const roomId = getFromLocalStorageAndDecrypt('roomName');
    deleteItemFromLocalStorage('roomName');
    deleteItemFromLocalStorage('callType');
    deleteItemFromLocalStorage('call_connection_status');
    callLogs.update(roomId, {
        "endTime": callLogs.initTime(),
        "sessionStatus": "closed"
    });
    Store.dispatch(showConfrence({
        showComponent: false,
        showStreamingComponent: false,
        showCalleComponent: false
    }));
    resetPinAndLargeVideoUser();
    Store.dispatch(hideModal());
    resetCallData();
    reconcileCallLogsFromServer();
}

// Keep the call log entry in sync with the actual call participants.
// When more than one remote participant is present the call is a group call, so the
// log must show the group icon and list everyone. Participants can arrive at different
// times (peers already in the room when you join, or users added mid-call), so this is
// called whenever the participant set changes. callLogs.update merges the user list,
// so passing the current remote participants keeps the entry complete without losing
// anyone who already left.
const syncCallLogParticipants = () => {
    const roomId = getFromLocalStorageAndDecrypt('roomName');
    if (!roomId) return;
    // remoteStream can contain the local user's own entry, so count only the OTHER
    // participants. A one-to-one call has exactly one other participant; without
    // excluding the local user, remoteJids.length would be 2 and the call would be
    // wrongly upgraded to a group call (group icon on a one-to-one log).
    const remoteJids = remoteStream
        .map(item => item.fromJid)
        .filter(Boolean)
        .filter(jid => !isLocalUser(jid));
    if (remoteJids.length > 1) {
        callLogs.update(roomId, {
            "userList": remoteJids.join(','),
            "callMode": "onetomany"
        });
    }
}

// After a call ends/rejects the backend commits the call-log row quickly, but for a
// group (onetomany) call it reconciles the full participant set (e.g. a third invitee)
// a little later. A single immediate fetch can return the log before that happens, so
// the local store keeps an incomplete participant list until the user refreshes the
// page. Re-fetch a few times with backoff so the converged data lands on its own —
// setLocalData replaces the entry by roomId, so the later complete fetch wins.
const reconcileCallLogsFromServer = () => {
    Store.dispatch(fetchingCallLog(true));
    [0, 1500, 4000, 8000].forEach((delay) => {
        setTimeout(() => {
            callLogs.getCallLogsFromServer(1);
        }, delay);
    });
};

const ringing = (res) => {
    if (!onCall) {
        const callConnectionData = JSON.parse(getFromLocalStorageAndDecrypt("call_connection_status"));
        if (callConnectionData.callType === "audio") {
            localVideoMuted = true;
        }
        Store.dispatch(showConfrence({
            callStatusText: 'Ringing',
            showStreamingComponent: false,
            localStream,
            remoteStream,
            localVideoMuted,
            localAudioMuted,
            showComponent: true,
        }));
    } else {
        const {
            getState
        } = Store;
        const showConfrenceData = getState().showConfrenceData;
        const {
            data
        } = showConfrenceData;
        const index = remoteStream.findIndex(item => item.fromJid === res.userJid);
        if (index > -1) {
            remoteStream[index] = {
                ...remoteStream[index],
                status: res.status
            };
            Store.dispatch(showConfrence({
                ...(data || {}),
                remoteStream: remoteStream
            }));
        }
    }
}

const connecting = (res) => {
    updatingUserStatusInRemoteStream(res.usersStatus);
    let roomId = getFromLocalStorageAndDecrypt('roomName');
    encryptAndStoreInLocalStorage('callingComponent', false)
    const showConfrenceData = Store.getState().showConfrenceData;
    const {
        data
    } = showConfrenceData;
    // If 'data.showStreamingComponent' property value is TRUE means, already call is connected &
    // Streaming data has been shared between users. That's why we check condition here,
    // If 'data.showStreamingComponent' is FALSE, then set the 'CONNECTING' state to display.
    if (data && !data.showStreamingComponent) {
        remoteStream = [];
        encryptAndStoreInLocalStorage("connecting", true);
        Store.dispatch(showConfrence({
            showComponent: true,
            showStreamingComponent: false,
            showCallingComponent: false
        }))
        // Preserve the original startTime across reconnects so the call-log
        // duration reflects the full call, not just the final segment.
        const existing = callLogs.getCallLogByRoomId(roomId);
        const update = { "sessionStatus": res.sessionStatus };
        if (!existing || !existing.startTime) {
            update.startTime = callLogs.initTime();
        }
        callLogs.update(roomId, update);
    }
}

const updateCallConnectionStatus = (usersStatus) => {
    const callConnectionData = JSON.parse(getFromLocalStorageAndDecrypt("call_connection_status"));
    let usersLen;
    if (usersStatus.length) {
        let currentUsers = usersStatus.filter(el => el.status.toLowerCase() !== CALL_STATUS_ENDED);
        usersLen = currentUsers.length;
    }
    let callDetailsObj = {
        ...callConnectionData,
        callMode: ((callConnectionData?.groupId && callConnectionData.groupId !== null && callConnectionData.groupId !== "") || usersLen > 2) ? "onetomany" : "onetoone"
    }
    encryptAndStoreInLocalStorage("call_connection_status", JSON.stringify(callDetailsObj));
}

const connected = (res) => {
    const userIndex = remoteStream.findIndex(item => item.fromJid === res.userJid);
    const behaviorResponse = SDK.getCallBehaviour();
    let behavior = "call";
    if (behaviorResponse.statusCode === 200) {
        behavior = behaviorResponse.data;
    }
    if (behavior === "meet" || userIndex > -1) {
        let usersStatus = res.usersStatus;
        updatingUserStatusInRemoteStream(usersStatus);
        updateCallConnectionStatus(usersStatus);
        const {
            getState,
            dispatch
        } = Store;
        const showConfrenceData = getState().showConfrenceData;
        const {
            data
        } = showConfrenceData;
        let showComponent = !!data.showComponent;
        let showStreamingComponent = !!data.showStreamingComponent;
        if (!showStreamingComponent) {
            deleteItemFromLocalStorage('connecting');
            showComponent = false;
            showStreamingComponent = true;
        }
        dispatch(showConfrence({
            ...(data || {}),
            showComponent,
            showStreamingComponent,
            remoteStream,
            localStream,
            status: res.callStatus,
            localVideoMuted: localVideoMuted,
            localAudioMuted: localAudioMuted,
            remoteVideoMuted: remoteVideoMuted,
            remoteAudioMuted: remoteAudioMuted,
            callStatusText: CALL_STATUS_CONNECTED
        }));
    }
}

const disconnected = (res) => {
    let roomId = getFromLocalStorageAndDecrypt('roomName');
    let vcardData = getLocalUserDetails();
    let currentUser = vcardData?.fromUser;
    currentUser = currentUser + "@" + REACT_APP_XMPP_SOCKET_HOST;
    updatingUserStatusInRemoteStream(res.usersStatus);
    let disconnectedUser = res.userJid;
    disconnectedUser = disconnectedUser.includes("@") ? disconnectedUser.split('@')[0] : disconnectedUser;
    if (remoteStream.length < 1 || disconnectedUser === currentUser) {
        deleteItemFromLocalStorage('roomName');
        deleteItemFromLocalStorage('callType');
        deleteItemFromLocalStorage('call_connection_status');
        callLogs.update(roomId, {
            "endTime": callLogs.initTime(),
            "sessionStatus": res.sessionStatus
        });
        Store.dispatch(showConfrence({
            showComponent: false,
            showStreamingComponent: false,
            showCalleComponent: false
        }));
        resetPinAndLargeVideoUser();
        Store.dispatch(hideModal());
        resetCallData();
    } else {
        Store.dispatch(showConfrence({
            showComponent: false,
            showStreamingComponent: true,
            showCallingComponent: false,
            localStream: localStream,
            remoteStream: remoteStream,
            fromJid: "",
            status: "REMOTESTREAM",
            localVideoMuted: localVideoMuted,
            localAudioMuted: localAudioMuted,
            remoteVideoMuted: remoteVideoMuted,
            remoteAudioMuted: remoteAudioMuted
        }))
        resetPinAndLargeVideoUser(res.fromJid);
        removingRemoteStream(res);
    }
    reconcileCallLogsFromServer();
}

export const localstoreCommon = () => {
    encryptAndStoreInLocalStorage('callingComponent', false)
    deleteItemFromLocalStorage('roomName');
    deleteItemFromLocalStorage('callType');
    deleteItemFromLocalStorage('call_connection_status');
    deleteItemFromLocalStorage('inviteStatus');
    encryptAndStoreInLocalStorage("hideCallScreen", false);
};

export const dispatchCommon = () => {
    Store.dispatch(showConfrence({
        callStatusText: null,
        showComponent: false,
        showStreamingComponent: false,
        stopSound: true,
        showCalleComponent: false
    }));
    Store.dispatch(callConversion());
    Store.dispatch(hideModal());
    Store.dispatch(callDurationTimestamp());
    Store.dispatch(resetConferencePopup());
    resetCallData();
};

const handleEngagedOrBusyStatus = (res) => {
    let roomId = getFromLocalStorageAndDecrypt('roomName');
    updatingUserStatusInRemoteStream(res.usersStatus);
    if (res.sessionStatus === "closed") {
        callLogs.update(roomId, {
            "endTime": callLogs.initTime(),
            "sessionStatus": res.sessionStatus
        });
        const callStatusMsg = res.status === "engaged" ? CALL_ENGAGED_STATUS_MESSAGE : CALL_BUSY_STATUS_MESSAGE;
        dispatchDisconnected(callStatusMsg);
        localCallDataClearAndDiscardUi();
        reconcileCallLogsFromServer();
    } else {
        if (remoteStream && Array.isArray(remoteStream) && remoteStream.length < 1) {
            return;
        }
        const {
            getState
        } = Store;
        const showConfrenceData = getState().showConfrenceData;
        const {
            data
        } = showConfrenceData;
        if (!onCall) {
            let callConnectionData = JSON.parse(getFromLocalStorageAndDecrypt('call_connection_status'))
            let userList = callConnectionData.userList.split(",");
            let updatedUserList = [];
            userList.forEach(user => {
                if (user !== res.userJid) {
                    updatedUserList.push(user);
                }
            });
            callConnectionData.userList = updatedUserList.join(",");
            if (callConnectionData.callMode === "onetomany" && !callConnectionData.groupId) {
                if (updatedUserList.length > 1) {
                    callConnectionData.callMode = "onetomany";
                } else {
                    callConnectionData.callMode = "onetoone";
                    callConnectionData.to = updatedUserList[0];
                }
            }
            encryptAndStoreInLocalStorage("call_connection_status", JSON.stringify(callConnectionData));
            Store.dispatch(CallConnectionState(callConnectionData));
        }
        let userDetails = getUserDetails(res.userJid);
        let toastMessage = res.status === "engaged" ? `${userDetails.displayName} is on another call` : `${userDetails.displayName} is busy`;
        toast.error(toastMessage);
        removingRemoteStream(res);
        if (data.showStreamingComponent) {
            resetPinAndLargeVideoUser(res.userJid);
        }
        Store.dispatch(showConfrence({
            ...(data || {}),
            remoteStream: remoteStream,
            remoteVideoMuted,
            remoteAudioMuted
        }));
    }
}

const ended = (res) => {
    deleteItemFromLocalStorage('inviteStatus');
    let roomId = getFromLocalStorageAndDecrypt('roomName');
    if (res.sessionStatus === "closed") {
        let callConnectionData = null;
        if (remoteStream && !onCall && !res.carbonAttended) {
            // Call ended before attend
            callConnectionData = JSON.parse(getFromLocalStorageAndDecrypt('call_connection_status'));
        }
        callLogs.update(roomId, {
            "endTime": callLogs.initTime(),
            "sessionStatus": res.sessionStatus
        });
        dispatchDisconnected();
        if (callConnectionData) {
            clearMissedCallNotificationTimer();
        }
        localstoreCommon();
        Store.dispatch(showConfrence({
            showCalleComponent: false,
            showStreamingComponent: false,
            showComponent: false,
            callStatusText: "ended",
            stopSound: true
        }));
        Store.dispatch(callConversion());
        Store.dispatch(hideModal());
        Store.dispatch(CallConnectionState(res));
        if (callConnectionData) {
            const callDetailObj = callConnectionData ? {
                ...callConnectionData
            } : {};
            callDetailObj['status'] = "ended";
            browserNotify.sendCallNotification(callDetailObj);
        }
        resetCallData();
    } else {
        if (!onCall || (remoteStream && Array.isArray(remoteStream) && remoteStream.length < 1)) {
            return;
        }
        removingRemoteStream(res);
        resetPinAndLargeVideoUser(res.userJid);
        updateCallConnectionStatus(res.usersStatus);
        const {
            getState
        } = Store;
        const showConfrenceData = getState().showConfrenceData;
        const {
            data
        } = showConfrenceData;
        Store.dispatch(showConfrence({
            ...(data || {}),
            remoteStream: remoteStream,
            remoteVideoMuted,
            remoteAudioMuted
        }));
    }
    reconcileCallLogsFromServer();
}

const reconnecting = (res) => {
    updatingUserStatusInRemoteStream(res.usersStatus);
    const {
        getState
    } = Store;
    const showConfrenceData = getState().showConfrenceData;
    const {
        data
    } = showConfrenceData;
    let vcardData = getLocalUserDetails();
    let currentUser = vcardData?.fromUser + "@" + REACT_APP_XMPP_SOCKET_HOST;
    if (currentUser === res.userJid) {
        Store.dispatch(showConfrence({
            showCallingComponent: false,
            ...(data || {}),
            localStream: localStream,
            remoteStream: remoteStream,
            fromJid: res.userJid,
            status: "REMOTESTREAM",
            localVideoMuted: localVideoMuted,
            localAudioMuted: localAudioMuted,
            remoteVideoMuted: remoteVideoMuted,
            remoteAudioMuted: remoteAudioMuted,
            callStatusText: CALL_STATUS_RECONNECT,
        }))
    } else {
        Store.dispatch(showConfrence({
            showCallingComponent: false,
            ...(data || {}),
            localStream: localStream,
            remoteStream: remoteStream,
            fromJid: res.userJid,
            status: "REMOTESTREAM",
            localVideoMuted: localVideoMuted,
            localAudioMuted: localAudioMuted,
            remoteVideoMuted: remoteVideoMuted,
            remoteAudioMuted: remoteAudioMuted
        }))
    }

}

const speaking = (res) => {
    if (!res.userJid) return;
    if (!res.localUser) {
        Store.dispatch(selectLargeVideoUser(res.userJid, res.volumeLevel));
    }
}

const userStatus = (res) => {
    updatingUserStatusInRemoteStream(res.usersStatus);
}

const hold = (res) => {
    updatingUserStatusInRemoteStream(res.usersStatus);
    const {
        getState
    } = Store;
    const showConfrenceData = getState().showConfrenceData;
    const {
        data
    } = showConfrenceData;
    Store.dispatch(showConfrence({
        showCallingComponent: false,
        ...(data || {}),
        localStream: localStream,
        remoteStream: remoteStream,
        fromJid: res.userJid,
        status: "REMOTESTREAM",
        localVideoMuted: localVideoMuted,
        localAudioMuted: localAudioMuted,
        remoteVideoMuted: remoteVideoMuted,
        remoteAudioMuted: remoteAudioMuted,
        callStatusText: CALL_STATUS_HOLD,
    }))
}

const subscribed = (res) => {
    const {
        getState,
        dispatch
    } = Store;
    const showConfrenceData = getState().showConfrenceData;
    const {
        data
    } = showConfrenceData;
    dispatch(showConfrence({
        ...(data || {}),
        localVideoMuted: data.mediaError ? localVideoMuted : false,
        localStream: localStream,
        remoteStream,
        localAudioMuted: localAudioMuted,
        status: "SUBSCRIBED"
    }));
}

const callStatus = (res) => {
    if (res.status === "ringing") {
        ringing(res);
    } else if (res.status === "connecting") {
        connecting(res);
    } else if (res.status === "connected") {
        connected(res);
    } else if (res.status === "busy") {
        handleEngagedOrBusyStatus(res);
    } else if (res.status === "disconnected") {
        disconnected(res);
    } else if (res.status === "engaged") {
        handleEngagedOrBusyStatus(res);
    } else if (res.status === "ended") {
        ended(res);
    } else if (res.status === "reconnecting") {
        reconnecting(res);
    } else if (res.status === "userstatus") {
        userStatus(res);
    } else if (res.status === "hold") {
        hold(res);
    }
}

export const callbacks = {
    channelConnectionListener: function (res) { },
    channelListener: handleIncomingChannelEvents,
    connectionListener: function (res) {
        const connStatus = res.status || "";
        const prevConnectionState = getConnectionStatus();
        if (connStatus === "CONNECTED") {
            handleIconTabUnreadChannel()
            encryptAndStoreInLocalStorage("connection_status", connStatus);
            setConnectionStatus(connStatus)
            Store.dispatch(WebChatConnectionState(connStatus));
            if (prevConnectionState !== 'RECONNECTING') {
                login();
            } else {
                serverReconnect();
            }
        } else if (connStatus === "DISCONNECTED") {
            if (isSameSession() && getFromSessionStorageAndDecrypt("isLogout") === null) {
                reconnect()
            }
            encryptAndStoreInLocalStorage("connection_status", connStatus);
            setConnectionStatus(connStatus)
            Store.dispatch(WebChatConnectionState(connStatus));
        } else if (connStatus === "CONNECTIONFAILED") {
            encryptAndStoreInLocalStorage("connection_status", connStatus);
            setConnectionStatus(connStatus)
            Store.dispatch(WebChatConnectionState(connStatus));
        } else if (connStatus === "RECONNECTING") {
            encryptAndStoreInLocalStorage("connection_status", connStatus);
            setConnectionStatus(connStatus)
            Store.dispatch(WebChatConnectionState(connStatus));
        } else if (connStatus === "AUTHFAIL") {
            logout();
            return;
        }
    },
    incomingCallListener: (res) => {
        localstoreCommon();
        resetCallData();
        resetLocalCallDataClearAndDiscardUiTimer();
        Store.dispatch(resetCallIntermediateScreen())

        remoteStream = [];
        localStream = null;
        let callMode = "onetoone";
        if (res.toUsers.length === 1 && res.groupId === null) {
            res.from = res.toUsers[0];
            res.to = res.userJid;
            if (res.callType === "audio") {
                localVideoMuted = true;
            }
        } else {
            callMode = "onetomany";
            res.from = res.userJid;
            res.to = res.groupId ? res.groupId : res.userJid;
            res.userList = res.allUsers.join(",");
            if (res.callType === "audio") {
                localVideoMuted = true;
            }
        }
        res.callMode = callMode;
        encryptAndStoreInLocalStorage("call_connection_status", JSON.stringify(res));
        let roomId = getFromLocalStorageAndDecrypt('roomName');

        if (roomId === "" || roomId === null || roomId === undefined) {
            resetPinAndLargeVideoUser();
            encryptAndStoreInLocalStorage('roomName', res.roomId);
            encryptAndStoreInLocalStorage('callType', res.callType)
            encryptAndStoreInLocalStorage('callFrom', res.from);
            if (res.callType === "audio") {
                localVideoMuted = true;
            }
            Store.dispatch(CallConnectionState(res));
            Store.dispatch(showConfrence({
                showComponent: false,
                showStreamingComponent: false,
                showCalleComponent: true
            }));
            updatingUserStatusInRemoteStream(res.usersStatus);
            browserNotify.sendCallNotification(res);
            startMissedCallNotificationTimer();
        } else {
            SDK.callEngaged();
        }

        // When joining an ongoing ad-hoc call (other participants already present),
        // the SDK may report toUsers.length === 1 with no groupId, so res.callMode is
        // "onetoone". usersStatus carries the full participant list (existing peers
        // included), so detect the real group call from its count and log it as a
        // group call instead of a one-to-one with just the caller until API refresh.
        const callParticipants = Array.isArray(res.usersStatus) ? res.usersStatus.length : 0;
        const isGroupCall = res.callMode === "onetomany" || callParticipants > 2;
        // For a group call, build the participant list from BOTH the invited set
        // (res.userList carries res.allUsers — caller + every invitee) and the live
        // usersStatus. usersStatus can lag at ring time (a co-invitee's status may not
        // have arrived yet), so relying on it alone drops participants from the local
        // call-log entry — the entry then shows only the caller until an API refresh.
        // Union the two so the entry is complete from the start, regardless of timing.
        let logUserList;
        if (isGroupCall) {
            const statusJids = Array.isArray(res.usersStatus)
                ? res.usersStatus.map(user => user.userJid).filter(Boolean)
                : [];
            const invitedJids = (res.userList || "").split(',').filter(Boolean);
            const mergedJids = [];
            invitedJids.concat(statusJids).forEach((jid) => {
                if (jid && mergedJids.indexOf(jid) === -1) mergedJids.push(jid);
            });
            logUserList = mergedJids.join(',');
        } else {
            logUserList = res.userList;
        }
        callLogs.insert({
            "callMode": isGroupCall ? "onetomany" : "onetoone",
            "callState": 0,
            "callTime": callLogs.initTime(),
            "callType": res.callType,
            "fromUser": res.from,
            "roomId": res.roomId,
            "userList": logUserList,
            "groupId": isGroupCall ? (res.groupId || '') : ''
        });
        setLocalUserOnCall(true);
        startCallingTimer();
        Store.dispatch(fetchingCallLog(true));
        callLogs.getCallLogsFromServer(1);
    },
    callStatusListener: (res) => {
        callStatus(res);
    },
    userTrackListener: (res) => {
        if (res.localUser) {
            if (!res.trackType) {
                return;
            }
            localStream = localStream || {};
            let mediaStream = null;
            if (res.track) {
                mediaStream = new MediaStream();
                mediaStream.addTrack(res.track);
            }
            localStream[res.trackType] = mediaStream;
            const {
                getState,
                dispatch
            } = Store;
            const showConfrenceData = getState().showConfrenceData;
            const {
                data
            } = showConfrenceData;
            const usersStatus = res.usersStatus;
            usersStatus.map((user) => {
                const index = remoteStream.findIndex(item => item.fromJid === user.userJid);
                if (index > -1) {
                    remoteStream[index] = {
                        ...remoteStream[index],
                        status: user.status
                    };
                    remoteVideoMuted[user.userJid] = user.videoMuted;
                    remoteAudioMuted[user.userJid] = user.audioMuted;
                } else {
                    let streamObject = {
                        id: uuidv4(),
                        fromJid: user.userJid,
                        status: user.status,
                    }
                    remoteStream.push(streamObject);
                    remoteVideoMuted[user.userJid] = user.videoMuted;
                    remoteAudioMuted[user.userJid] = user.audioMuted;
                }
            });
            const roomName = getFromLocalStorageAndDecrypt('roomName');
            if (roomName === "" || roomName == null || roomName == undefined) {
                const { roomId = "" } = SDK.getCallInfo();
                encryptAndStoreInLocalStorage('roomName', roomId);
            }

            dispatch(showConfrence({
                localVideoMuted: localVideoMuted,
                ...(data || {}),
                localStream: localStream,
                remoteStream,
                localAudioMuted: localAudioMuted,
                status: "LOCALSTREAM"
            }));

        } else {
            encryptAndStoreInLocalStorage('callingComponent', false);
            const streamType = res.trackType;
            let mediaStream = null;
            if (res.track) {
                mediaStream = new MediaStream();
                mediaStream.addTrack(res.track);
            }
            const streamUniqueId = `stream${streamType.charAt(0).toUpperCase() + streamType.slice(1)}Id`;
            updatingUserStatusInRemoteStream(res.usersStatus);
            const userIndex = remoteStream.findIndex(item => item.fromJid === res.userJid);
            if (userIndex > -1) {
                let {
                    stream
                } = remoteStream[userIndex];
                stream = stream || {};
                stream[streamType] = mediaStream;
                stream['id'] = uuidv4();
                stream[streamUniqueId] = uuidv4();
                remoteStream[userIndex]['stream'] = stream;
            } else {
                let streamObject = {
                    id: uuidv4(),
                    fromJid: res.userJid,
                    status: CALL_STATUS_CONNECTED,
                    stream: {
                        [streamUniqueId]: uuidv4(),
                        [streamType]: mediaStream
                    }
                }
                remoteStream.push(streamObject);
            }

            // A remote participant's stream connected. When joining an ongoing call the
            // already-present peers arrive here (not via callUserJoinedListener), so keep
            // the call log's participant list and group icon in sync as they connect.
            syncCallLogParticipants();

            // When remoteStream user length is one, set that user as large video user
            if (remoteStream.length === 2) {
                Store.dispatch(selectLargeVideoUser(res.userJid));
            } else {
                remoteStream.forEach((item) => {
                    return Store.dispatch(selectLargeVideoUser(item.userJid));
                });
            }

            const {
                showConfrenceData,
                callConversionData
            } = Store.getState();
            const {
                data
            } = showConfrenceData;
            Store.dispatch(showConfrence({
                showCallingComponent: false,
                localVideoMuted: localVideoMuted,
                ...(data || {}),
                localStream: localStream,
                remoteStream: remoteStream,
                fromJid: res.userJid,
                status: "REMOTESTREAM",
                localAudioMuted: localAudioMuted,
                remoteVideoMuted: remoteVideoMuted,
                remoteAudioMuted: remoteAudioMuted,
                callStatusText: CALL_STATUS_CONNECTED
            }));
            if (!onCall) {
                const { callQualityData } = Store.getState();
                if (callQualityData.data === "POOR") {
                    Store.dispatch(setPoorConnectionIcon(false));
                    Store.dispatch(setPoorConnectionPopUp(true));
                    setTimeout(() => {
                        Store.dispatch(setPoorConnectionIcon(true));
                        Store.dispatch(setPoorConnectionPopUp(false));
                    }, 5000);
                }
            }
            onCall = true;
            // Need to hide the call converison request & response screen when more than one remote
            // users joined in call
            if (remoteStream.length >= 3) {
                const status = callConversionData && callConversionData.status === CALL_CONVERSION_STATUS_REQ_WAITING ? {
                    status: CALL_CONVERSION_STATUS_CANCEL
                } : undefined;
                Store.dispatch(callConversion(status));
                status && SDK.callConversion(CALL_CONVERSION_STATUS_CANCEL);
            }
        }
    },
    muteStatusListener: (res) => {
        if (!res) return;
        let localUser = false;
        let vcardData = getLocalUserDetails();
        const currentUser = vcardData?.fromUser;
        let mutedUser = res.userJid;
        mutedUser = mutedUser.includes("@") ? mutedUser.split('@')[0] : mutedUser;
        if (res.localUser || currentUser === mutedUser) {
            localUser = true;
        }
        if (localUser) {
            if (res.trackType === CALL_TYPE_AUDIO) {
                localAudioMuted = res.isMuted;
            }
            if (res.trackType === CALL_TYPE_VIDEO) {
                localVideoMuted = res.isMuted;
            }
        } else {
            if (res.trackType === CALL_TYPE_AUDIO) {
                remoteAudioMuted[res.userJid] = res.isMuted;
                if (res.isMuted) {
                    Store.dispatch(selectLargeVideoUser(res.userJid, -100));
                }
            }
            if (res.trackType === CALL_TYPE_VIDEO) {
                remoteVideoMuted[res.userJid] = res.isMuted;
            }
        }

        const showConfrenceData = Store.getState().showConfrenceData;
        const {
            data
        } = showConfrenceData;
        let showComponent = data.showComponent;
        let showStreamingComponent = data.showStreamingComponent;
        let showCallingComponent = data.showCallingComponent;
        let showCalleComponent = data.showCalleComponent;

        Store.dispatch(showConfrence({
            ...data,
            showComponent: showComponent,
            showStreamingComponent: showStreamingComponent,
            showCallingComponent: showCallingComponent,
            showCalleComponent: showCalleComponent,
            localStream: localStream,
            remoteStream: remoteStream,
            fromJid: res.userJid,
            status: "MUTESTATUS",
            localVideoMuted: localVideoMuted,
            localAudioMuted: localAudioMuted,
            remoteVideoMuted: remoteVideoMuted,
            remoteAudioMuted: remoteAudioMuted
        }))
        updateCallTypeAfterCallSwitch();

    },
    missedCallListener: (res) => {
        callLogs.insert({
            "callMode": res.callMode,
            "callState": 0,
            "callTime": callLogs.initTime(),
            "callType": res.callType,
            "fromUser": res.from,
            "roomId": res.roomId,
            "userList": res.allUsers,
            "groupId": res.groupId
        });
    },
    callSwitchListener: (res) => {
        Store.dispatch(callConversion({
            status: res.status,
            fromUser: res.userJid
        }));
    },
    callSpeakingListener: (res) => {
        speaking(res);
    },
    callUsersUpdateListener: (res) => {
        remoteStream.forEach((item) => {
            if (!res.usersList.includes(item.fromJid)) {
                removeRemoteStream(item.fromJid);
            }
        });
        Store.dispatch(callIntermediateScreen({
            usersList: res.usersList
        }));
        subscribed(res);
    },
    inviteUsersListener: (res) => {
        updatingUserStatusInRemoteStream(res.usersStatus);
        const showConfrenceData = Store.getState().showConfrenceData;
        const {
            data
        } = showConfrenceData;
        Store.dispatch(showConfrence({
            ...(data || {}),
            status: "REMOTESTREAM",
            remoteStream: remoteStream
        }));
        // Adding participants to an ongoing call converts it into a group call.
        // Update callMode so the call log entry renders the group icon immediately,
        // instead of the last-added user's avatar until the next API refresh.
        callLogs.update(res.roomId, {
            "userList": res.userList,
            "callMode": "onetomany"
        });
        startCallingTimer();
    },
    mediaErrorListener: (res) => {
        if ((res.action === "subscribeCall" || res.action === "answerCall") && res.statusCode === 100607) {
            muteLocalVideo(true);
            const {
                getState
            } = Store;
            const showConfrenceData = getState().showConfrenceData;
            const {
                data
            } = showConfrenceData;
            Store.dispatch(showConfrence({
                ...(data || {}),
                mediaError: true,
                localVideoMuted: true
            }));
            // Don't show blocking modal for camera-only errors during call answer —
            // the call continues as audio-only. Show a non-blocking toast instead.
            toast.info("Camera unavailable — continuing with audio only");
            return;
        }
        Store.dispatch(showModal({
            open: true,
            modelType: res.callStatus === "MEDIA_PERMISSION_DENIED" ? 'mediaPermissionDenied' : 'mediaAccessError',
            ...res
        }));
    },
    messageListener: async function (res) {
        if (res.msgType === LOGOUT || res.msgType === CARBON_LOGOUT) {
            encryptAndStoreInSessionStorage("isLogout", true);
            setTimeout(async () => {
                if (isSameSession()) {
                    await deleteAllIndexedDb();
                    deleteItemFromLocalStorage("username");
                    deleteItemFromLocalStorage("auth_user");
                    deleteItemFromLocalStorage("getuserprofile");
                    deleteItemFromLocalStorage("session_start_time");
                    window.location.reload();
                }
            }, 2000);
            return;
        }

        if (res.msgType === "simBindLogout") {
            encryptAndStoreInSessionStorage("isLogout", true);
            encryptAndStoreInSessionStorage("is_sim_binding_logout", true);
            setTimeout(async () => {
                if (isSameSession()) {
                    await deleteAllIndexedDb();
                    deleteItemFromLocalStorage("username");
                    deleteItemFromLocalStorage("auth_user");
                    deleteItemFromLocalStorage("getuserprofile");
                    deleteItemFromLocalStorage("session_start_time");
                    window.location.reload();
                }
            }, 2000);
            return;
        }

        if (res.msgType === "newSession") {
            const newSession = getFromLocalStorageAndDecrypt("newSession");
            if (!newSession || newSession === null) {
                encryptAndStoreInSessionStorage("isLogout", true);
                setTimeout(async () => {
                    if (isSameSession()) {
                        await deleteAllIndexedDb();
                        deleteItemFromLocalStorage("username");
                        deleteItemFromLocalStorage("auth_user");
                        deleteItemFromLocalStorage("getuserprofile");
                        deleteItemFromLocalStorage("session_start_time");
                        window.location.reload();
                    }
                }, 2000);
                return;
            }
        }

        if (res.msgType === 'unreadUpdate' || res.msgType === MSG_CHAT_SEEN_ALL) {
            const readerId = res.publisherId || '';
            if (readerId && !isLocalUser(readerId)) {
                Store.dispatch(
                    MarkChatMessagesSeenAction({
                        fromUserId: readerId,
                        chatType: res.chatType || 'chat',
                        seenTimestamp: Date.now(),
                    }),
                );
            }
            return;
        }

        if (res.msgType === "receiveMessage" && res.chatType === CHAT_TYPE_GROUP && res.msgBody === "2") {
            const groupListRes = await SDK.getGroupsList();
            if (groupListRes && groupListRes.statusCode === 200) {
                let groupsData = groupListRes.data;
                if (Array.isArray(groupsData)) {
                    groupsData = groupsData.map(group => {
                        const currentGroup = getGroupData(group.groupJid);
                        if (group.groupName === group.groupId) {
                            return { ...group, groupName: currentGroup ? currentGroup.groupName : "" };
                        }
                        return group;
                    });
                }
                Store.dispatch(GroupsDataAction(groupsData));
            }
        }

        if (res.msgType === MSG_CLEAR_CHAT || res.msgType === MSG_CLEAR_CHAT_CARBON) {
            const { chatConversationHistory: { data = {} } = {} } = Store.getState();
            const chatMessages = data[res.fromUserId]?.messages || {};
            if (
                chatMessages &&
                (chatMessages[res.lastMsgId] === undefined || chatMessages[res.lastMsgId] === null || chatMessages[res.lastMsgId] === "")
            ) {
                Store.dispatch(ClearChatHistoryAction(res));
                Store.dispatch(ClearChatHistoryActionCommon(res));
                Store.dispatch(clearLastMessageinRecentChat(res.fromUserId));
                Store.dispatch(RemoveStaredMessagesClearChat(res));
                return;
            }
            Store.dispatch(ClearChatHistoryActionCommon(res));
            if (Object.keys(chatMessages).length === 0) {
                Store.dispatch(clearLastMessageinRecentChat(res.fromUserId));
            }
            if (res.favourite === "0") {
                Store.dispatch(RemoveStaredMessagesClearChat(res));
            }
        }

        if (res.msgType === MSG_DELETE_CHAT || res.msgType === MSG_DELETE_CHAT_CARBON) {
            const archivedChats = getArchivedChats();
            if (archivedChats.includes(res.fromUserId)) {
                SDK.updateArchiveChat(formatUserIdToJid(res.fromUserId, res.chatType), false);
            }
            // Delete the user from recent chat list
            Store.dispatch(deleteActiveChatAction(res));
            Store.dispatch(DeleteChatHistoryAction(res));
            const chatId = getActiveConversationChatId();
            if (res.fromUserId === chatId) Store.dispatch(ActiveChatResetAction());
            Store.dispatch(RemoveStaredMessagesDeleteChat(res));
        }

        if (res.msgType === "userBlockStatus" || res.msgType === "carbonUserBlockStatus") {
            Store.dispatch(updateContactWhoBlockedMeAction(res.blockedUserId, res.type));
            return;
        }

        if (res.msgType === DELETE_CALL_LOG) {
            Store.dispatch(deleteAllCallLog(res));
        } else {
            Store.dispatch(MessageAction(res));
        }
        if (res.nickName && isGroupChat(res.chatType)) {
            const normalizedNickName = normalizeXmlText(res.nickName);

            const groupJid = formatUserIdToJid(res.fromUserId, CHAT_TYPE_GROUP);
            const currentGroup = getGroupData(groupJid);

            if (normalizedNickName !== res.groupId && (!currentGroup || currentGroup.groupName !== normalizedNickName)) {
                const obj = {
                    groupJid,
                    groupProfile: {
                        nickName: normalizedNickName,
                    },
                };
                Store.dispatch(GroupDataUpdateAction(obj));
            }
        }
    },
    editMessageListener: async function (res) {
        // Handled Edited message callbacks here
        const { msgType } = res;
        if (
            msgType === "carbonSentMessage" ||
            msgType === "receiveMessage" ||
            msgType === "carbonReceiveMessage"
        ) {
            Store.dispatch(MessageAction(res));
        }
    },
    groupProfileListener: async function (res) {
        if (res?.groupJid) {
            const groupData = getGroupData(res.groupJid);
            const groupPartRes = await SDK.getGroupParticipants(res.groupJid);
            if (groupPartRes && groupPartRes.statusCode === 200) {
                setGroupParticipantsByGroupId(res.groupJid, groupPartRes.data.participants);
            }
            handleTempArchivedChats(res.groupJid, CHAT_TYPE_GROUP);

            // Send notification when current user is added to a group
            if (res.msgType === GROUP_USER_ADDED && res.newUserId === getLocalUserId()) {
                const publisherId = res?.publisherJid ? getUserIdFromJid(res.publisherJid) : null;
                const isPublisherCurrentUser = publisherId && isLocalUser(publisherId);

                // Check not current publisher user's action for himself
                if (!isPublisherCurrentUser) {
                    const groupName = res?.groupName || groupData?.groupName;
                    const titleName = groupName ? `the group "${groupName}"` : 'a new Group';
                    const publisherName = getUserDetails(res?.publisherJid)?.displayName || res?.publisherProfile?.nickName || 'Someone';
                    const notificationTitle = `You were added to ${titleName} by ${publisherName}`;
                    const groupImage = groupData?.groupImage || groupData?.thumbImage || '';
                    const groupId = res.groupId || getUserIdFromJid(res.groupJid);

                    sendNotification(groupName || "New Group", groupImage, notificationTitle, groupId);
                }
            }
            if (groupData && res.msgType === GROUP_USER_ADDED && res.newUserId == getLocalUserId() && (groupData.historyEnabled == 1)) {
                const chatMessageRes = await SDK.getChatMessages({ toJid: res.groupJid });
                if (chatMessageRes.statusCode == 200) {
                    let updatedChatMessages = chatMessageRes
                    updatedChatMessages.data.historyEnabledUser = 1;
                    Store.dispatch(ChatMessageHistoryDataAction(updatedChatMessages));
                }
            }
            if (groupData && isActiveConversationUserOrGroup(res.groupJid)) {
                // Fetch the group participants details
                if (
                    [
                        GROUP_USER_ADDED,
                        GROUP_USER_REMOVED,
                        GROUP_USER_MADE_ADMIN,
                        GROUP_PROFILE_INFO_UPDATED,
                        GROUP_USER_LEFT
                    ].indexOf(res.msgType) > -1
                ) {
                    if (groupPartRes && groupPartRes.statusCode === 200) {
                        setGroupParticipants(groupPartRes.data);
                    }
                }
            }
            else if (res.msgType === GROUP_USER_ADDED) {
                const groupListRes = await SDK.getGroupsList();
                if (groupListRes && groupListRes.statusCode === 200) {
                    let groupsData = groupListRes.data;
                    if (Array.isArray(groupsData)) {
                        groupsData = groupsData.map(group => {
                            const currentGroup = getGroupData(group.groupJid);
                            if (group.groupName === group.groupId) {
                                return { ...group, groupName: currentGroup ? currentGroup.groupName : "" };
                            }
                            return group;
                        });
                    }
                    Store.dispatch(GroupsDataAction(groupsData));
                }
                const recentChatsRes = await SDK.getRecentChatsByPagination();

                if (recentChatsRes && recentChatsRes.statusCode === 200) {
                    Store.dispatch(RecentChatAction(recentChatsRes.data));
                }
            }
            Store.dispatch(GroupDataUpdateAction(res));
        }
    },
    groupMemberListListener: function (res, communicationType) {
        // We are maintaing the separate group members list reducer for chat & call
        // Because If currently user in group chat screen, at the same time if user gets the group call
        // & attended the group call, then try to invite the new user from group, then need to show the
        // Group member list in invite user popup. So in this situation, Current chat screen & call group is
        // different, to avoid the group override maintain the separate groups for call & chat.
        if (communicationType !== 'call') {
            Store.dispatch(GroupsMemberListAction(res));
        }
        Store.dispatch(currentCallGroupMembers(res));
    },
    presenceListener: function (res) {
        Store.dispatch(PresenceDataAction(res))
    },
    replyMessageListener: function (res) {
        Store.dispatch(ReplyMessageAction(res));
    },
    setUserToken: function (token) {
        if (!token) {
            deleteItemFromLocalStorage('token');
            return;
        }
        encryptAndStoreInLocalStorage("token", token);
    },
    // New Callback Listeners from New SDK
    friendsListListener: function (res) {
        Store.dispatch(RosterPermissionAction(res.permission));
        Store.dispatch(RosterDataAction(res.users));
    },
    userProfileListener: async function (res) {
        if (res.fromUserId && res.msgType === 'seen_receipt') {

            const update = {};
            update.seenReceipt = Number(res.privacySettings);
            Store.dispatch(PrivacySettingsAction(update));
            return;
        }
        if (res.msgType === 'hide_profile') {

            const hideVal = Number(res.privacySettings);
            if (res.fromUserId && isLocalUser(res.fromUserId)) {

                // Keep payload shape simple (top-level key). Other places read either
                // privacySettings.hideProfile or privacySettingsData.hideProfile so
                // reducers/components will pick this up.
                Store.dispatch(PrivacySettingsAction({ hideProfile: hideVal }));
                return;
            }

            // Otherwise it's for another user — refresh that user's profile in store
            // so the contact's visibility/image gets updated.
            if (res.fromUserId && !isLocalUser(res.fromUserId)) {

                const targetUserId = res.fromUserId;
                await SDK.getUserProfile(targetUserId);
                return;
            }
        }
        Store.dispatch(setUserInfoArr([res]));
        let authUser = getFromLocalStorageAndDecrypt('auth_user');
        if (authUser.username === res.userId) {
            Store.dispatch(VCardDataAction(res));
        } else {
            const VCardProfileData = {
                ...res,
                ...(!REACT_APP_CONTACT_SYNC ? { name: res.nickName } : {}),
                isDeletedUser: false,
                displayName: res.nickName,
            }
            Store.dispatch(VCardContactDataAction(VCardProfileData));
        }
    },
    favouriteMessageListener: function (res) {
        Store.dispatch(UpdateFavouriteStatus(res));
        Store.dispatch(UpdateStarredMessages(res));
    },
    groupMsgInfoListener: function (res) {
        Store.dispatch(messageInfoAction(res));
    },
    mediaUploadListener: function (res) {
        Store.dispatch(MediaUploadDataAction(res));
    },
    mediaDownloadListener: function (res) {
        if (res?.msgId != null) {
            Store.dispatch(MediaDownloadDataAction(res));
        }
    },
    /**
     * This listener will be called, when a same user logged in another device
     * and block any user from that device, then this listener will receive the
     * list blocked user details res as same as 'SDK.getUsersIBlocked()'
     */
    blockUserListener: function (res) {
        Store.dispatch(updateBlockedContactAction(res.blockedUserId, res.type));
    },
    singleMessageDataListener: function (res) {
        Store.dispatch(updateMsgByLastMsgId(res));
    },
    muteChatListener: function (res) {
        if (res.muteSetting) {
            updateMuteSettings(res.isMuted);
        } else {
            updateMuteStatus(res);
        }
    },
    archiveChatListener: function (res) {
        Store.dispatch(updateArchiveStatusRecentChat(res));
    },
    userSettingsListener: function (res) {
        setLocalWebsettings("archive", res.archive === 1);
        Store.dispatch(webSettingLocalAction({
            "isEnableArchived": res.archive === 1
        }));
    },
    helper: {
        getDisplayName: (metadata) => {
            let vcardData = getLocalUserDetails();
            if (vcardData && vcardData.nickName) {
                return vcardData.nickName;
            }
            return "Anonymous user ";
        },
        getImageUrl: () => {
            let vcardData = getLocalUserDetails();
            if (vcardData) {
                return vcardData.image;
            }
            return "";
        }
    },
    callUserJoinedListener: function (res) {
        if (res.userJid && !res.localUser) {
            updateStoreRemoteStream();
            // Only toast a genuinely new participant. On reconnect this event re-fires for
            // peers who never left, so suppress it when we have already announced them.
            if (!announcedCallParticipants.has(res.userJid)) {
                announcedCallParticipants.add(res.userJid);
                handleCallParticipantToast(res.userJid, "join");
            }
            // When a participant is added to the call by anyone (not just the local user),
            // this client only receives a "user joined" event — not the invite events.
            // Sync the call log so it reflects the group call immediately instead of
            // keeping the original one-to-one user/icon until the next API refresh.
            syncCallLogParticipants();
        }
    },
    callUserLeftListener: function (res) {
        if (res.userJid && !res.localUser) {
            // The remote user has left the call (e.g. they failed to reconnect within
            // the timeout window). Actually remove their tile from the conference stream
            // and clear any pin/large-video selection pointing at them — previously this
            // only re-dispatched the unchanged stream, so the user stayed on screen.
            removingRemoteStream(res);
            resetPinAndLargeVideoUser(res.userJid);
            // Genuinely left — forget them so a later real re-join is announced again.
            announcedCallParticipants.delete(res.userJid);
            handleCallParticipantToast(res.userJid, "left");

            // Count the participants still in the call other than the local user. If at
            // least one remote peer remains it is still a group call, so just refresh the
            // stream. If none remain the call has no other peer (one-to-one), so end it.
            const remainingRemoteUsers = remoteStream.filter(
                item => item.fromJid && !isLocalUser(item.fromJid)
            );
            if (remainingRemoteUsers.length > 0) {
                updateStoreRemoteStream();
            } else {
                endCallAfterAllRemoteLeft();
            }
        }
    },
    adminBlockListener: function (res) {
        let callConnectionGroupJid = null;
        if (onCall) {
            callConnectionGroupJid = Store.getState()?.callConnectionDate?.data?.groupId
        }
        if (isLocalUser(res.toUserId)) {
            if (res.blockStatus === "1") {
                Store.dispatch(adminBlockStatusUpdate(res));
                SDK.endCall();
                resetCallData();
                stopRecorder();
                logout("block");
            }
        } else if (isSingleChatJID(res.toUserJid)) {
            if (isActiveConversationUserOrGroup(res.toUserId) && res.blockStatus === "1") {
                stopRecorder();
            }
            Store.dispatch(VCardContactDataAction({
                userId: res.toUserId,
                isAdminBlocked: res.blockStatus === "1"
            }));
            // Optimistically mark the blocked user in the currently open group's
            // participant list so the member list/header update immediately, instead
            // of waiting for a fresh getGroupParticipants IQ (which lags one step).
            if (res.blockStatus === "1") {
                const memberListData = Store.getState()?.groupsMemberListData?.data;
                if (memberListData?.participants?.some(p => p.userId === res.toUserId)) {
                    const updatedParticipants = memberListData.participants.map(p =>
                        p.userId === res.toUserId ? { ...p, isAdminBlocked: true } : p
                    );
                    setGroupParticipants({ ...memberListData, participants: updatedParticipants });
                }
            }
        } else {
            if (isActiveConversationUserOrGroup(res.toUserId)) {
                if (res.blockStatus === "1") {
                    Store.dispatch(messageForwardReset());
                    Store.dispatch(ActiveChatResetAction());
                    stopRecorder();
                    toast.info("This group is no longer available")
                    Store.dispatch(hideModal())
                    if (callConnectionGroupJid === res.toUserJid) {
                        disconnectCallConnection()
                    }
                }
            }
            else if (callConnectionGroupJid === res.toUserJid && res.blockStatus === "1") {
                disconnectCallConnection()
            }
            Store.dispatch(GroupDataUpdateAction({
                groupJid: res.toUserJid,
                isAdminBlocked: res.blockStatus === "1"
            }));
        }
    },
    userDeletedListener: async (userJid) => {
        let data = await getDataFromRoster(getUserIdFromJid(userJid));
        Store.dispatch(deletedUserInfo({ userId: getUserIdFromJid(userJid) }));
        Store.dispatch(VCardContactDataAction({
            ...data,
            isDeletedUser: true,
            email: "",
            image: "",
            isFriend: false,
            mobileNumber: "",
            name: "Deleted User",
            nickName: "Deleted User",
            displayName: "Deleted User",
            status: ""
        }));
    },
    callConnectionQualityListener: (data) => {
        Store.dispatch(setCallQuality(data.quality));
        if (data.quality === "POOR") {
            Store.dispatch(setPoorConnectionPopUp(true));
            setTimeout(() => {
                Store.dispatch(setPoorConnectionIcon(true));
                Store.dispatch(setPoorConnectionPopUp(false));
            }, 5000);
        }
        if (data.quality === "AVERAGE" || data.quality === "GOOD") {
            Store.dispatch(setPoorConnectionIcon(false));
            Store.dispatch(setPoorConnectionPopUp(false));
        }
    }
}

let localCallDataClearAndDiscardUiTimer = null;

export const localCallDataClearAndDiscardUi = () => {
    localCallDataClearAndDiscardUiTimer = setTimeout(() => {
        localstoreCommon();
        dispatchCommon();
    }, DISCONNECTED_SCREEN_DURATION);
}

export const resetLocalCallDataClearAndDiscardUiTimer = () => clearTimeout(localCallDataClearAndDiscardUiTimer);

export const setLocalUserOnCall = (data) => {
    localUserOnCall = data;
}

export const isLocalUserOnCall = () => localUserOnCall;
